import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getBanners = (setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("get", Constants.END_POINT.BANNER);
    if (res.success && res.data) {
        dispatch({
            type: types.BANNERS,
            payload: res.data,
        });
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

// Hits the banner-specific upload endpoint (not the generic uploadImage(s) in
// uploadFiles.js) because this is the one that enforces the Home Screen
// Carousel spec (format, 1MB max, 2:1 aspect ratio, 800x400-1456x734px) and
// returns a clear validation message on rejection.
const uploadBannerImage = (file) => async (dispatch) => {
    const formData = new FormData();
    formData.append("image", file);

    const res = await api("post", Constants.END_POINT.BANNER_UPLOAD, formData, {}, "multipart/form-data");
    if (res.success && res.data) {
        return res.data.path;
    }
    dispatch(showToast({ severity: "error", summary: res.message }));
    return null;
};

const addBanner = (image, next = () => {}, setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) setLoading(true);

    const res = await api("post", Constants.END_POINT.BANNER, { image });
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getBanners());
        next();
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    if (setLoading) setLoading(false);
    dispatch(hideLoaderAction());
};

const deleteBanner = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.BANNER + id);
    if (res.success) {
        dispatch(getBanners());
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getBanners, uploadBannerImage, addBanner, deleteBanner };
